import SessionCapture from './SessionCapture';

// FIXME: import/no-default-export
// eslint-disable-next-line import/no-default-export
export default SessionCapture;
